const escapeHtml = (value) => {
  if (value == null || value === "") return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
};

// Opens a print-friendly RTL table in a new window. Returns false if the popup was blocked.
// columns: [{ header, format: (row) => string }]
export const printTable = ({ title, summary, columns, rows }) => {
  const headerHtml = columns
    .map((col) => `<th>${escapeHtml(col.header)}</th>`)
    .join("");
  const bodyHtml = rows
    .map(
      (row) =>
        `<tr>${columns
          .map((col) => `<td>${escapeHtml(col.format(row))}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const html = `<!DOCTYPE html>
<html dir="rtl" lang="he">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${escapeHtml(title)}</title>
    <style>
      @page { size: A4; margin: 12mm; }
      * { box-sizing: border-box; }
      body { font-family: Arial, sans-serif; direction: rtl; margin: 16px; color: #222; font-size: 13px; }
      h2 { margin: 0 0 6px; font-size: 18px; }
      p { margin: 0 0 12px; }
      table { width: 100%; border-collapse: collapse; }
      th, td { border: 1px solid #bfbfbf; padding: 6px 8px; text-align: center; overflow-wrap: anywhere; }
      th { background: #f0f0f0; font-weight: 600; white-space: nowrap; }
      thead { display: table-header-group; } /* repeat header on every printed page */
      tr { page-break-inside: avoid; break-inside: avoid; }
      tbody tr:nth-child(even) td { background: #fafafa; }
      @media print {
        body { margin: 0; }
        th, tbody tr:nth-child(even) td { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    </style>
  </head>
  <body>
    <h2>${escapeHtml(title)}</h2>
    <p>${escapeHtml(summary)}</p>
    <table>
      <thead><tr>${headerHtml}</tr></thead>
      <tbody>${bodyHtml}</tbody>
    </table>
  </body>
</html>`;

  // Note: passing "noopener" to window.open makes it return null, so detach the opener manually
  const printWindow = window.open("", "_blank");
  if (!printWindow) return false;
  printWindow.opener = null;
  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 250);
  return true;
};
